import React from 'react'
import { Heading } from '../components/Heading';
import { AccountsUsersPage } from '../components/AccountsUsers/AccountsUsersPage';

export function AccountsUsers() {
    return (
        <>
            <Heading title="Cuentas y Usuarios" />
            <AccountsUsersPage />
        </>
    )
}

export default AccountsUsers